/*
 * @Description: 登录页canvas背景
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-12-10 17:10:19
 * @LastEditTime: 2022-01-04 11:50:42
*/
export function startBg(dom) {
  var canvas = document.querySelector(dom)
  var context = canvas.getContext('2d')
  var cw, ch
  var stars = []

  // 当窗口大小改变时
  function setSize() {
    // window.onresize = setSize();
    cw = window.innerWidth
    ch = window.innerHeight
    canvas.height = ch
    canvas.width = cw
  }

  setSize()
  window.onresize = setSize()

  function Star() {}
  Star.prototype = {
    init: function() {
      this.w = rand(0, cw)
      this.h = rand(0, ch)
      this.r = 5 * Math.random()
      this.speedX = rand(-1, 1)
      this.speedY = rand(-1, 1)
    },
    draw: function() {
      context.fillStyle = 'rgba(1,46,102,0.5)'
      context.beginPath()
      context.arc(this.w, this.h, this.r, 0, Math.PI * 2)
      context.fill()
    },
    move: function() {
      this.w += this.speedX
      this.h += this.speedY
      if (this.w < 0 || this.w > cw) {
        this.speedX *= -1
      }
      if (this.h < 0 || this.h > ch) {
        this.speedY *= -1
      }
      this.draw()
    }
  }

  function Line() {}
  Line.prototype = {
    // 星星之间的连线
    initStarLine: function() {
      this.colorStar = '#162a51'
      this.colorStop = 'rgba(1,72,164,0.1)'
      // this.colorStop = '#2363C2'
    },
    // 鼠标与星星之间的连线
    initNewLine: function() {
      this.colorStar = '#162a51'
      this.colorStop = 'rgba(1,72,164,0.1)'
    },
    drawLine: function(ow, oh, nw, nh) {
      var dx = ow - nw
      var dy = oh - nh
      var d = Math.sqrt(dx * dx + dy * dy)
      if (d < 60) {
        var line = context.createLinearGradient(ow, oh, nw, nh)
        line.addColorStop(0, this.colorStar)
        line.addColorStop(1, this.colorStop)

        context.beginPath()
        context.moveTo(ow, oh)
        context.lineTo(nw, nh)
        context.StrokeWidth = 1
        context.strokeStyle = line
        context.stroke()
        context.restore()
      }
    }
  }
  // 生成范围在min~max之间的随机数
  function rand(min, max) {
    return Math.random() * (max - min) + min
  }
  function create(num) {
    for (var i = 0; i < num; i++) {
      var star = new Star()
      star.init()
      star.draw()
      stars.push(star)
    }
  }
  create(300)

  timmer && clearInterval(timmer)
  var timmer = setInterval(function() {
    context.clearRect(0, 0, cw, ch)
    for (var i of stars) {
      i.move()
      for (var j = 0; j < stars.length / 2; j++) {
        var line = new Line()
        line.initStarLine()
        line.drawLine(i.w, i.h, stars[j].w, stars[j].h)
      }
    }
  }, 50)

  document.onmousemove = function(e) {
    var e = e || window.event
    var mw = e.clientX
    var mh = e.clientY
    for (var i of stars) {
      var line = new Line()
      line.initNewLine()
      line.drawLine(i.w, i.h, mw, mh)
    }
  }
}
